














import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {}
})
export default class PGRowDateValue extends Vue {
  @Prop() private value!: string;
  @Prop() private isEditable!: boolean;
  private textValue!: string;

  constructor() {
    super();
    this.textValue = this.value;
  }

  saveChange(): void {
    this.$emit('valueChanged', this.textValue);
  }

  @Watch('value')
  refresh() {
    this.textValue = this.value;
  }
}
